import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, LogIn, X } from 'lucide-react';
import ServiceCard from '../../../../components/customer/services/servicecards/ServiceCards';
// import '../../../../assets/css/screens/customer/services/Services.css';
import LoginModal from '../../../../components/customer/auth/loginModal/LoginModal';

import axios from "axios";
import '../../../../assets/css/subscreens/customer/home/topservices/TopServices.css';
import AppContext from '../../../../context/AppContext';


const TopServices = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${baseUrl}/user/viewcategory`)
      .then((res) => {

        console.log("API RESPONSE:", res.data);

        const categoriesData = res.data.categories || [];

        const formatted = categoriesData.map((cat) => ({
          id: cat.id,
          name: cat.categoryName,        // ✅ FIXED
          description: cat.description,
          image: `${baseUrlForFile}/${cat.categoryImage}`
        }));

        setCategories(formatted);
      })
      .catch((err) => console.log(err));
  }, [baseUrl, baseUrlForFile]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  // 🔥 LOGIN CHECK FUNCTION
  const handleServiceClick = (service) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");

    if (!isLoggedIn) {
  setShowLoginPrompt(true);
  return;
}

    navigate(
      `/services/${service?.name?.toLowerCase()?.replace(/\s+/g, '-')}`
    );
  };

  return (
    <>

      <section className="nfys-section">

        {/* HEADER */}
        <div className="nfys-header">
          <h1 className="nfys-title">Our Services</h1>

          <button
            className="nfys-view-all"
            onClick={() => navigate('/services')}
          >
            View all <ArrowRight size={16} />
          </button>
        </div>

        {/* GRID */}
        <div className="nfys-grid">
          {categories?.map((cat, idx) => (
            <ServiceCard
              key={cat?.id}
              item={{
                name: cat?.name || "No Name",
                description: cat?.description || "No description",
                image: cat?.image
              }}
              index={idx}
              onClick={() => handleServiceClick(cat)}
            />
          ))}
        </div>

      </section>
      {showLoginPrompt && (
  <div
    className="nfys-modal-overlay"
    onClick={() => setShowLoginPrompt(false)}
  >
    <div
      className="nfys-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="nfys-modal-close"
        onClick={() => setShowLoginPrompt(false)}
      >
        <X size={18} />
      </button>

      <div className="nfys-modal-icon">
        <LogIn size={34} />
      </div>

      <h3>Login Required</h3>

      <p>
        Sign in to continue exploring our services and connect with trusted professionals.
      </p>

      <div className="nfys-modal-actions">
        <button
          className="nfys-modal-cancel"
          onClick={() => setShowLoginPrompt(false)}
        >
          Maybe Later
        </button>

        <button
          className="nfys-modal-login"
          onClick={() => {
            setShowLoginPrompt(false);
            setShowLoginModal(true);
          }}
        >
          Login Now
        </button>
      </div>
    </div>
  </div>
)}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onLoginSuccess={() => {
          localStorage.setItem("isLoggedIn", "true"); // 🔥 IMPORTANT
          setShowLoginModal(false);
        }}
      />
    </>
  );

};

export default TopServices;